import React, {SyntheticEvent} from 'react';
import classNames from "classnames";
import {IconProps} from "../icons";


import './DocumentContextMenuItem.css';


export interface DocumentContextMenuItemProps {
    handleClose: () => void;


    onClick: (event: SyntheticEvent) => boolean | any;
    condition?: boolean;
    text?: string;
    Icon?: React.ComponentType<IconProps>;
    className?: string;
}

export const DocumentContextMenuItem = ({handleClose, onClick, text, Icon, className}: DocumentContextMenuItemProps) => {
    let content = <>
        {Icon ? (
            <Icon size={20}/>
        ) : null}
        {text ? <span className='DocumentContextMenuItem-text'>{text}</span> : null}
    </>;
    return (
        <div
            className={classNames({
                'DocumentContextMenuItem body-large': true,
                [className!]: className,
            })}
            onClick={(e) => {
                e.stopPropagation();
                const clickResult = onClick(e);
                if (clickResult !== false){
                    handleClose();
                }
            }}
        >
            {content}
        </div>
    )
}